import { AxiosRequestConfig } from "axios";

import { useApi } from "../useApi/useApi";
import { Target } from "../../models/Target";

/**
 * Fetch hook for upload targets
 */
export const useGetTargets = () => {
  const req: AxiosRequestConfig = {
    url: "/api/target",
    method: "get",
    headers: { "Content-Type": "application/json" },
  };
  const { state } = useApi<Target[]>(req);
  return state;
};
